<template>
    <div>
        <!-- 航空动力 -->
        <div class="title" ref="title">
            <transition name="text" appear>
                <div class="textArea">
                    航空动力
                </div>
            </transition>
        </div>
        <div class="engine">
            <div class="WP WP40" ref="WP40">
                <div class="left">
                    <el-tabs tab-position="left" class="custom-tabs" v-model="engineList.wp40.activeName"
                        @tab-click="handTabClick($event, engineList.wp40)" type="horizontal">
                        <el-tab-pane label="重要参数" name="重要参数">
                            <div class="parameter" style="margin-left: 10%;">
                                <transition name="importance" appear v-if="engineList.wp40.importance">
                                    <div style="width: 100%;height: 100%;display: flex;flex-wrap: wrap;">
                                        <div v-for="item, key in engineList.wp40.importanceParameters"
                                            class="parameterContent">
                                            <div class="parameterLine icon">
                                                <img :src="iconList[key]" style="width:4vw">
                                            </div>
                                            <div class="parameterLine">{{ item.name }}</div>
                                            <div class="parameterLine">{{ item.value }}</div>
                                        </div>
                                    </div>
                                </transition>


                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="全部参数" name="全部参数" style="scale: 0.8;transform: translateY(-12%);">
                            <transition name="all" appear v-if="engineList.wp40.all">
                                <el-table :data="engineList.wp40.allParameters" class="parameterTable"
                                    style="background-color: red;margin-left: 20%;">
                                    <el-table-column prop="name" label="技术指标">
                                    </el-table-column>
                                    <el-table-column prop="value" label="参数">
                                    </el-table-column>
                                    <el-table-column prop="unit" label="单位">
                                    </el-table-column>
                                </el-table>
                            </transition>

                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="right">
                    <div class="name">
                        <p class="paramName">涡喷发动机</p>
                        <p class="paramModel">TH-WP40</p>
                    </div>
                    <div class="product">
                        <video v-lazy-load preload="metadata" autoplay muted loop class="backgroundVideo">
                            <source :src="require('@/assets/engine/发动机40.mp4')" type="video/mp4" />
                        </video>
                    </div>
                    <el-button type="primary" icon="el-icon-download" class="downloadButton" @click="downFile">产品手册下载</el-button>
                </div>
            </div>

            <div class="WP WP60" ref="WP60">
                <div class="right">
                    <div class="name">
                        <p class="paramName">涡喷发动机</p>
                        <p class="paramModel">TH-WP60</p>
                    </div>
                    <div class="product">
                        <video v-lazy-load preload="metadata" autoplay muted loop class="backgroundVideo">
                            <source :src="require('@/assets/engine/WP60.mp4')" type="video/mp4" />
                        </video>
                    </div>
                    <el-button type="primary" icon="el-icon-download" class="downloadButton" @click="downFile">产品手册下载</el-button>
                </div>
                <div class="left">
                    <el-tabs tab-position="right" class="custom-tabs" v-model="engineList.wp60.activeName"
                        @tab-click="handTabClick($event, engineList.wp60)" type="horizontal">
                        <el-tab-pane label="重要参数" name="重要参数">
                            <div class="parameter" style="margin-right: 10%;">
                                <transition name="importance" appear v-if="engineList.wp60.importance">
                                    <div style="width: 100%;height: 100%;display: flex;flex-wrap: wrap;">
                                        <div v-for="item, key in engineList.wp60.importanceParameters"
                                            class="parameterContent">
                                            <div class="parameterLine icon">
                                                <img :src="iconList[key]" style="width:4vw">
                                            </div>
                                            <div class="parameterLine">{{ item.name }}</div>
                                            <div class="parameterLine">{{ item.value }}</div>
                                        </div>
                                    </div>

                                </transition>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="全部参数" name="全部参数" style="scale: 0.8;transform: translateY(-12%);">
                            <transition name="all" appear v-if="engineList.wp60.all">
                                <el-table :data="engineList.wp60.allParameters" class="parameterTable"
                                    style="background-color: red;">
                                    <el-table-column prop="name" label="技术指标">
                                    </el-table-column>
                                    <el-table-column prop="value" label="参数">
                                    </el-table-column>
                                    <el-table-column prop="unit" label="单位">
                                    </el-table-column>
                                </el-table>
                            </transition>

                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>

            <div class="WP WP100" ref="WP100">
                <div class="left">
                    <el-tabs tab-position="left" class="custom-tabs" v-model="engineList.wp100.activeName"
                        @tab-click="handTabClick($event, engineList.wp100)" type="horizontal">
                        <el-tab-pane label="重要参数" name="重要参数">
                            <div class="parameter" style="margin-left: 10%;">
                                <transition name="importance" appear v-if="engineList.wp100.importance">
                                    <div style="width: 100%;height: 100%;display: flex;flex-wrap: wrap;">
                                        <div v-for="item, key in engineList.wp100.importanceParameters"
                                            class="parameterContent">
                                            <div class="parameterLine icon">
                                                <img :src="iconList[key]" style="width:4vw">
                                            </div>
                                            <div class="parameterLine">{{ item.name }}</div>
                                            <div class="parameterLine">{{ item.value }}</div>
                                        </div>
                                    </div>

                                </transition>


                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="全部参数" name="全部参数" style="scale: 0.8;transform: translateY(-12%);">
                            <transition name="all" appear v-if="engineList.wp100.all">
                                <el-table :data="engineList.wp100.allParameters" class="parameterTable"
                                    style="background-color: red;margin-left: 20%;">
                                    <el-table-column prop="name" label="技术指标">
                                    </el-table-column>
                                    <el-table-column prop="value" label="参数">
                                    </el-table-column>
                                    <el-table-column prop="unit" label="单位">
                                    </el-table-column>
                                </el-table>
                            </transition>

                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="right">
                    <div class="name">
                        <p class="paramName">涡喷发动机</p>
                        <p class="paramModel">TH-WP100</p>
                    </div>
                    <div class="product">
                        <video v-lazy-load preload="metadata" autoplay muted loop class="backgroundVideo">
                            <source :src="require('@/assets/engine/WP100.mp4')" type="video/mp4" />
                        </video>
                    </div>
                    <el-button type="primary" icon="el-icon-download" class="downloadButton" @click="downFile">产品手册下载</el-button>
                </div>
            </div>

            <div class="WP WP125" ref="WP125">
                <div class="right">
                    <div class="name">
                        <p class="paramName">涡喷发动机</p>
                        <p class="paramModel">TH-WP125</p>
                    </div>
                    <div class="product">
                        <video v-lazy-load preload="metadata" autoplay muted loop class="backgroundVideo">
                            <source :src="require('@/assets/engine/WP125.mp4')" type="video/mp4" />
                        </video>
                    </div>
                    <el-button type="primary" icon="el-icon-download" class="downloadButton" @click="downFile">产品手册下载</el-button>
                </div>
                <div class="left">
                    <el-tabs tab-position="right" class="custom-tabs" v-model="engineList.wp125.activeName"
                        @tab-click="handTabClick($event, engineList.wp125)" type="horizontal">
                        <el-tab-pane label="重要参数" name="重要参数">
                            <div class="parameter" style="margin-right: 10%;">
                                <transition name="importance" appear v-if="engineList.wp125.importance">
                                    <div style="width: 100%;height: 100%;display: flex;flex-wrap: wrap;">
                                        <div v-for="item, key in engineList.wp125.importanceParameters"
                                            class="parameterContent">
                                            <div class="parameterLine icon">
                                                <img :src="iconList[key]" style="width:4vw">
                                            </div>
                                            <div class="parameterLine">{{ item.name }}</div>
                                            <div class="parameterLine">{{ item.value }}</div>
                                        </div>
                                    </div>

                                </transition>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="全部参数" name="全部参数" style="scale: 0.8;transform: translateY(-12%);">
                            <transition name="all" appear v-if="engineList.wp125.all">
                                <el-table :data="engineList.wp125.allParameters" class="parameterTable"
                                    style="background-color: red;">
                                    <el-table-column prop="name" label="技术指标">
                                    </el-table-column>
                                    <el-table-column prop="value" label="参数">
                                    </el-table-column>
                                    <el-table-column prop="unit" label="单位">
                                    </el-table-column>
                                </el-table>
                            </transition>

                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>

            <div class="WP WP160" ref="WP160">
                <div class="left">
                    <!-- <div class="parameter" style="margin-top: 20%;">
                        <el-row>
                            <el-col :span="2"><img :src="require('@/assets/engine/耗油量.png')"
                                    style="width:2.5vw"></el-col>
                            <el-col :span="10" class="paramName">最大推力</el-col>
                            <el-col :span="10">158daN</el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2"><img :src="require('@/assets/engine/耗油量.png')"
                                    style="width:2.5vw"></el-col>
                            <el-col :span="10" class="paramName">最大转速油耗率</el-col>
                            <el-col :span="10">1.35kg/daN·H</el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2"><img :src="require('@/assets/engine/耗油量.png')"
                                    style="width:2.5vw"></el-col>
                            <el-col :span="10" class="paramName">最大转速油耗量</el-col>
                            <el-col :span="10">4.56L/min</el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2"><img :src="require('@/assets/engine/耗油量.png')"
                                    style="width:2.5vw"></el-col>
                            <el-col :span="10" class="paramName">重量</el-col>
                            <el-col :span="10">23kg</el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2"><img :src="require('@/assets/engine/耗油量.png')"
                                    style="width:2.5vw"></el-col>
                            <el-col :span="10" class="paramName">直径</el-col>
                            <el-col :span="10">264mm</el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2"><img :src="require('@/assets/engine/耗油量.png')"
                                    style="width:2.5vw"></el-col>
                            <el-col :span="10" class="paramName">长度</el-col>
                            <el-col :span="10">620mm</el-col>
                        </el-row>
                    </div> -->
                    <el-tabs tab-position="left" class="custom-tabs" v-model="engineList.wp160.activeName"
                        @tab-click="handTabClick($event, engineList.wp160)" type="horizontal">
                        <el-tab-pane label="重要参数" name="重要参数">
                            <div class="parameter" style="margin-left: 10%;">
                                <transition name="importance" appear v-if="engineList.wp160.importance">
                                    <div style="width: 100%;height: 100%;display: flex;flex-wrap: wrap;">
                                        <div v-for="item, key in engineList.wp160.importanceParameters"
                                            class="parameterContent">
                                            <div class="parameterLine icon">
                                                <img :src="iconList[key]" style="width:4vw">
                                            </div>
                                            <div class="parameterLine">{{ item.name }}</div>
                                            <div class="parameterLine">{{ item.value }}</div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="全部参数" name="全部参数" style="scale: 0.8;transform: translateY(-12%);">
                            <transition name="all" appear v-if="engineList.wp160.all">
                                <el-table :data="engineList.wp160.allParameters" class="parameterTable"
                                    style="background-color: red;margin-left: 20%;">
                                    <el-table-column prop="name" label="技术指标">
                                    </el-table-column>
                                    <el-table-column prop="value" label="参数">
                                    </el-table-column>
                                    <el-table-column prop="unit" label="单位">
                                    </el-table-column>
                                </el-table>
                            </transition>

                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="right">
                    <div class="name">
                        <p class="paramName">涡喷发动机</p>
                        <p class="paramModel">TH-WP160</p>
                    </div>
                    <div class="product">
                        <video v-lazy-load preload="metadata" autoplay muted loop class="backgroundVideo">
                            <source :src="require('@/assets/engine/WP160.mp4')" type="video/mp4" />
                        </video>
                    </div>
                    <el-button type="primary" icon="el-icon-download" class="downloadButton" @click="downFile">产品手册下载</el-button>
                </div>
            </div>

            <div class="WP WZ150" ref="WZ150">
                <div class="right">
                    <div class="name">
                        <p class="paramName">涡轴发动机</p>
                        <p class="paramModel">TH-WZ150</p>
                    </div>
                    <div class="product">
                        <video v-lazy-load preload="metadata" autoplay muted loop class="backgroundVideo">
                            <source :src="require('@/assets/engine/WZ150.mp4')" type="video/mp4" />
                        </video>
                    </div>
                    <el-button type="primary" icon="el-icon-download" class="downloadButton" @click="downFile">产品手册下载</el-button>
                </div>
                <div class="left">
                    <el-tabs tab-position="right" class="custom-tabs" v-model="engineList.wz150.activeName"
                        @tab-click="handTabClick($event, engineList.wz150)" type="horizontal">
                        <el-tab-pane label="重要参数" name="重要参数">
                            <div class="parameter" style="margin-right: 10%;">
                                <transition name="importance" appear v-if="engineList.wz150.importance">
                                    <div style="width: 100%;height: 100%;display: flex;flex-wrap: wrap;">
                                        <div v-for="item, key in engineList.wz150.importanceParameters"
                                            class="parameterContent">
                                            <div class="parameterLine icon">
                                                <img :src="iconList[key]" style="width:4vw">
                                            </div>
                                            <div class="parameterLine">{{ item.name }}</div>
                                            <div class="parameterLine">{{ item.value }}</div>
                                        </div>
                                    </div>

                                </transition>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="全部参数" name="全部参数" style="scale: 0.8;">
                            <transition name="all" appear v-if="engineList.wz150.all">
                                <el-table :data="engineList.wz150.allParameters" class="parameterTable"
                                    style="background-color: red;">
                                    <el-table-column prop="name" label="技术指标">
                                    </el-table-column>
                                    <el-table-column prop="value" label="参数">
                                    </el-table-column>
                                    <el-table-column prop="unit" label="单位">
                                    </el-table-column>
                                </el-table>
                            </transition>

                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>

            <div class="WP WD200" ref="WD200">
                <div class="left">
                    <el-tabs tab-position="left" class="custom-tabs" v-model="engineList.wd200.activeName"
                        @tab-click="handTabClick($event, engineList.wd200)" type="horizontal">
                        <el-tab-pane label="重要参数" name="重要参数">
                            <div class="parameter" style="margin-left: 10%;">
                                <transition name="importance" appear v-if="engineList.wd200.importance">
                                    <div style="width: 100%;height: 100%;display: flex;flex-wrap: wrap;">
                                        <div v-for="item, key in engineList.wd200.importanceParameters"
                                            class="parameterContent">
                                            <div class="parameterLine icon">
                                                <img :src="iconList[key]" style="width:4vw">
                                            </div>
                                            <div class="parameterLine">{{ item.name }}</div>
                                            <div class="parameterLine">{{ item.value }}</div>
                                        </div>
                                    </div>

                                </transition>


                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="全部参数" name="全部参数" style="scale: 0.8;">
                            <transition name="all" appear v-if="engineList.wd200.all">
                                <el-table :data="engineList.wd200.allParameters" class="parameterTable"
                                    style="background-color: red;margin-left: 20%;">
                                    <el-table-column prop="name" label="技术指标">
                                    </el-table-column>
                                    <el-table-column prop="value" label="参数">
                                    </el-table-column>
                                    <el-table-column prop="unit" label="单位">
                                    </el-table-column>
                                </el-table>
                            </transition>

                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="right">
                    <div class="name">
                        <p class="paramName">涡轴发电系统</p>
                        <p class="paramModel">TH-WD200</p>
                    </div>
                    <div class="product">
                        <video v-lazy-load preload="metadata" autoplay muted loop class="backgroundVideo">
                            <source :src="require('@/assets/engine/WD200.mp4')" type="video/mp4" />
                        </video>
                    </div>
                    <el-button type="primary" icon="el-icon-download" class="downloadButton" @click="downFile">产品手册下载</el-button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            id: 'title',
            distance: 0,

            //参数指标
            engineList: {
                wp40: {
                    importance: true,
                    all: false,
                    activeName: '重要参数',
                    previousName: '重要参数',
                    importanceParameters: {
                        oilConsumption: {
                            name: '最大转速耗油量',
                            value: '1.35L/min'
                        },
                        diameter: {
                            name: '直径',
                            value: '147.6mm'
                        },
                        length: {
                            name: '长度',
                            value: '342mm'
                        },
                        thrust: {
                            name: '最大推力',
                            value: '42daN'
                        },
                        weight: {
                            name: '重量',
                            value: '3.8kg'
                        },
                        oliRate: {
                            name: '最大转速耗油率',
                            value: '1.5kg/daN·h'
                        }
                    },
                    allParameters: [
                        {
                            name: '最大推力',
                            value: '42',
                            unit: 'daN'
                        },
                        {
                            name: '最大转速耗油率',
                            value: '1.5',
                            unit: 'kg/daN·h'
                        },
                        {
                            name: '最大转速耗油量',
                            value: '1.35',
                            unit: 'L/min'
                        },
                        {
                            name: '重量',
                            value: '3.8',
                            unit: 'kg'
                        },
                        {
                            name: '直径',
                            value: '147.6',
                            unit: 'mm'
                        },
                        {
                            name: '长度',
                            value: '342',
                            unit: 'mm'
                        },
                        {
                            name: '怠速转速',
                            value: '32000',
                            unit: 'rpm'
                        },
                        {
                            name: '最高转速',
                            value: '96000',
                            unit: 'rpm'
                        },
                        {
                            name: '空气流量',
                            value: '0.7',
                            unit: 'kg/s'
                        },
                        {
                            name: '增压比',
                            value: '4.0',
                            unit: ''
                        },
                        {
                            name: '排气温度',
                            value: '750',
                            unit: '℃'
                        },
                        {
                            name: '最大启动高度',
                            value: '4000',
                            unit: 'm'
                        },
                        {
                            name: '最大飞行高度',
                            value: '10000',
                            unit: 'm'
                        },
                        {
                            name: '最大机动过载',
                            value: '6',
                            unit: 'g'
                        },
                        {
                            name: '最大冲击过载',
                            value: '25',
                            unit: 'g'
                        },
                        {
                            name: '保养周期',
                            value: '25',
                            unit: 'h'
                        }
                    ]


                },
                wp60: {
                    importance: true,
                    all: false,
                    activeName: '重要参数',
                    previousName: '重要参数',
                    importanceParameters: {
                        oilConsumption: {
                            name: '最大转速耗油量',
                            value: '1.83L/min'
                        },
                        diameter: {
                            name: '直径',
                            value: '178mm'
                        },
                        length: {
                            name: '长度',
                            value: '410mm'
                        },
                        thrust: {
                            name: '最大推力',
                            value: '59daN'
                        },
                        weight: {
                            name: '重量',
                            value: '5.8kg'
                        },
                        oliRate: {
                            name: '最大转速耗油率',
                            value: '1.45kg/daN·h'
                        }
                    },
                    allParameters: [
                        {
                            name: '最大推力',
                            value: '59',
                            unit: 'daN'
                        },
                        {
                            name: '最大转速耗油率',
                            value: '1.45',
                            unit: 'kg/daN·h'
                        },
                        {
                            name: '最大转速耗油量',
                            value: '1.83',
                            unit: 'L/min'
                        },
                        {
                            name: '重量',
                            value: '5.8',
                            unit: 'kg'
                        },
                        {
                            name: '直径',
                            value: '178',
                            unit: 'mm'
                        },
                        {
                            name: '长度',
                            value: '410',
                            unit: 'mm'
                        },
                        {
                            name: '怠速转速',
                            value: '27000',
                            unit: 'rpm'
                        },
                        {
                            name: '最高转速',
                            value: '78000',
                            unit: 'rpm'
                        },
                        {
                            name: '空气流量',
                            value: '1.0',
                            unit: 'kg/s'
                        },
                        {
                            name: '增压比',
                            value: '4.2',
                            unit: ''
                        },
                        {
                            name: '排气温度',
                            value: '750',
                            unit: '℃'
                        },
                        {
                            name: '最大启动高度',
                            value: '4000',
                            unit: 'm'
                        },
                        {
                            name: '最大飞行高度',
                            value: '10000',
                            unit: 'm'
                        },
                        {
                            name: '最大机动过载',
                            value: '6',
                            unit: 'g'
                        },
                        {
                            name: '最大冲击过载',
                            value: '25',
                            unit: 'g'
                        },
                        {
                            name: '保养周期',
                            value: '25',
                            unit: 'h'
                        }
                    ]
                },
                wp100: {
                    importance: true,
                    all: false,
                    activeName: '重要参数',
                    previousName: '重要参数',
                    importanceParameters: {
                        oilConsumption: {
                            name: '最大转速耗油量',
                            value: '1.45L/min'
                        },
                        diameter: {
                            name: '直径',
                            value: '203mm'
                        },
                        length: {
                            name: '长度',
                            value: '510mm'
                        },
                        thrust: {
                            name: '最大推力',
                            value: '95daN'
                        },
                        weight: {
                            name: '重量',
                            value: '11.5kg'
                        },
                        oliRate: {
                            name: '最大转速耗油率',
                            value: '2.95kg/daN·h'
                        }
                    },
                    allParameters: [
                        {
                            name: '最大推力',
                            value: '95',
                            unit: 'daN'
                        },
                        {
                            name: '最大转速耗油率',
                            value: '1.45',
                            unit: 'kg/daN·h'
                        },
                        {
                            name: '最大转速耗油量',
                            value: '2.95',
                            unit: 'L/min'
                        },
                        {
                            name: '重量',
                            value: '11.5',
                            unit: 'kg'
                        },
                        {
                            name: '直径',
                            value: '203',
                            unit: 'mm'
                        },
                        {
                            name: '长度',
                            value: '510',
                            unit: 'mm'
                        },
                        {
                            name: '怠速转速',
                            value: '24000',
                            unit: 'rpm'
                        },
                        {
                            name: '最高转速',
                            value: '64000',
                            unit: 'rpm'
                        },
                        {
                            name: '空气流量',
                            value: '1.6',
                            unit: 'kg/s'
                        },
                        {
                            name: '增压比',
                            value: '4.0',
                            unit: ''
                        },
                        {
                            name: '排气温度',
                            value: '750',
                            unit: '℃'
                        },
                        {
                            name: '最大启动高度',
                            value: '4000',
                            unit: 'm'
                        },
                        {
                            name: '最大飞行高度',
                            value: '10000',
                            unit: 'm'
                        },
                        {
                            name: '最大机动过载',
                            value: '6',
                            unit: 'g'
                        },
                        {
                            name: '最大冲击过载',
                            value: '25',
                            unit: 'g'
                        },
                        {
                            name: '保养周期',
                            value: '25',
                            unit: 'h'
                        }
                    ]


                },
                wp125: {
                    importance: true,
                    all: false,
                    activeName: '重要参数',
                    previousName: '重要参数',
                    importanceParameters: {
                        oilConsumption: {
                            name: '最大转速耗油量',
                            value: '3.74L/min'
                        },
                        diameter: {
                            name: '直径',
                            value: '236mm'
                        },
                        length: {
                            name: '长度',
                            value: '550mm'
                        },
                        thrust: {
                            name: '最大推力',
                            value: '125daN'
                        },
                        weight: {
                            name: '重量',
                            value: '15kg'
                        },
                        oliRate: {
                            name: '最大转速耗油率',
                            value: '1.4kg/daN·h'
                        }
                    },
                    allParameters: [
                        {
                            name: '最大推力',
                            value: '125',
                            unit: 'daN'
                        },
                        {
                            name: '最大转速耗油率',
                            value: '1.4',
                            unit: 'kg/daN·h'
                        },
                        {
                            name: '最大转速耗油量',
                            value: '3.74',
                            unit: 'L/min'
                        },
                        {
                            name: '重量',
                            value: '15',
                            unit: 'kg'
                        },
                        {
                            name: '直径',
                            value: '236',
                            unit: 'mm'
                        },
                        {
                            name: '长度',
                            value: '550',
                            unit: 'mm'
                        },
                        {
                            name: '怠速转速',
                            value: '20000',
                            unit: 'rpm'
                        },
                        {
                            name: '最高转速',
                            value: '60000',
                            unit: 'rpm'
                        },
                        {
                            name: '空气流量',
                            value: '2.0',
                            unit: 'kg/s'
                        },
                        {
                            name: '增压比',
                            value: '4.5',
                            unit: ''
                        },
                        {
                            name: '排气温度',
                            value: '750',
                            unit: '℃'
                        },
                        {
                            name: '最大启动高度',
                            value: '5000',
                            unit: 'm'
                        },
                        {
                            name: '最大飞行高度',
                            value: '10000',
                            unit: 'm'
                        },
                        {
                            name: '最大机动过载',
                            value: '6',
                            unit: 'g'
                        },
                        {
                            name: '最大冲击过载',
                            value: '25',
                            unit: 'g'
                        },
                        {
                            name: '保养周期',
                            value: '25',
                            unit: 'h'
                        }
                    ]


                },
                wp160: {
                    importance: true,
                    all: false,
                    activeName: '重要参数',
                    previousName: '重要参数',
                    importanceParameters: {
                        oilConsumption: {
                            name: '最大转速耗油量',
                            value: '4.56L/min'
                        },
                        diameter: {
                            name: '直径',
                            value: '264mm'
                        },
                        length: {
                            name: '长度',
                            value: '620mm'
                        },
                        thrust: {
                            name: '最大推力',
                            value: '158daN'
                        },
                        weight: {
                            name: '重量',
                            value: '23kg'
                        },
                        oliRate: {
                            name: '最大转速耗油率',
                            value: '1.35kg/daN·h'
                        }
                    },
                    allParameters: [
                        {
                            name: '最大推力',
                            value: '158',
                            unit: 'daN'
                        },
                        {
                            name: '最大转速耗油率',
                            value: '1.35',
                            unit: 'kg/daN·h'
                        },
                        {
                            name: '最大转速耗油量',
                            value: '4.56',
                            unit: 'L/min'
                        },
                        {
                            name: '重量',
                            value: '23',
                            unit: 'kg'
                        },
                        {
                            name: '直径',
                            value: '264',
                            unit: 'mm'
                        },
                        {
                            name: '长度',
                            value: '620',
                            unit: 'mm'
                        },
                        {
                            name: '怠速转速',
                            value: '20000',
                            unit: 'rpm'
                        },
                        {
                            name: '最高转速',
                            value: '55000',
                            unit: 'rpm'
                        },
                        {
                            name: '空气流量',
                            value: '2.7',
                            unit: 'kg/s'
                        },
                        {
                            name: '增压比',
                            value: '4.5',
                            unit: ''
                        },
                        {
                            name: '排气温度',
                            value: '750',
                            unit: '℃'
                        },
                        {
                            name: '最大启动高度',
                            value: '5000',
                            unit: 'm'
                        },
                        {
                            name: '最大飞行高度',
                            value: '10000',
                            unit: 'm'
                        },
                        {
                            name: '最大机动过载',
                            value: '6',
                            unit: 'g'
                        },
                        {
                            name: '最大冲击过载',
                            value: '25',
                            unit: 'g'
                        },
                        {
                            name: '保养周期',
                            value: '25',
                            unit: 'h'
                        }
                    ]
                },
                wz150: {
                    importance: true,
                    all: false,
                    activeName: '重要参数',
                    previousName: '重要参数',
                    importanceParameters: {
                        power: {
                            name: '输出功率',
                            value: '150kW'
                        },
                        oilConsumption: {
                            name: '耗油率',
                            value: '0.55kg/kW·h'
                        },
                        reductionRatio: {
                            name: '齿轮减速比',
                            value: '5.4:1'
                        },
                        weight: {
                            name: '重量',
                            value: '3.8kg'
                        },
                        length: {
                            name: '长X宽X高',
                            value: '680X712X410(mm)'
                        },
                        oliRate:{
                            name: '输出轴转速',
                            value: '5978rpm'
                        }
                    },
                    allParameters: [
                        {
                            name: '输出功率',
                            value: '150',
                            unit: 'kW'
                        },
                        {
                            name: '耗油率',
                            value: '0.55',
                            unit: 'kg/kW·h'
                        },
                        {
                            name: '齿轮减速比',
                            value: '5.4:1',
                            unit: ''
                        },
                        {
                            name: '重量',
                            value: '65',
                            unit: 'kg'
                        },
                        {
                            name: '长X宽X高',
                            value: '680X712X410',
                            unit: 'mm'
                        },
                        {
                            name: '输出轴转速',
                            value: '5978',
                            unit: 'rpm'
                        },
                        {
                            name: '怠速转速',
                            value: '30000',
                            unit: 'rpm'
                        },
                        {
                            name: '最高转速',
                            value: '61200',
                            unit: 'rpm'
                        },
                        {
                            name: '滑油容积',
                            value: '3000',
                            unit: 'mL'
                        },
                        {
                            name: '最大滑油消耗量',
                            value: '50',
                            unit: 'mL/h'
                        },
                        {
                            name: '排气温度',
                            value: '750',
                            unit: '℃'
                        },
                    ]
                },
                wd200: {
                    importance: true,
                    all: false,
                    activeName: '重要参数',
                    previousName: '重要参数',
                    importanceParameters: {
                        generatedPower: {
                            name: '发电功率',
                            value: '200kW'
                        },
                        GenerationEfficiency: {
                            name: '发电效率',
                            value: '≥15%'
                        },
                        oliRate: {
                            name: '耗油率',
                            value: '0.55kg/kW·h'
                        },
                        airFlow: {
                            name: '空气流量',
                            value: '1.6kg/s'
                        },
                        weight: {
                            name: '重量',
                            value: '≤60kg'
                        },
                        length: {
                            name: '长X宽X高',
                            value: '1000X650X400(mm)'
                        }
                    },
                    allParameters: [
                        {
                            name: '发电功率',
                            value: '200',
                            unit: 'kW'
                        },
                        {
                            name: '发电效率',
                            value: '≥15',
                            unit: '%'
                        },
                        {
                            name: '耗油率',
                            value: '0.55',
                            unit: 'kg/kW·h'
                        },
                        {
                            name: '空气流量',
                            value: '1.6',
                            unit: 'kg/s'
                        },
                        {
                            name: '重量',
                            value: '≤60',
                            unit: 'kg'
                        },
                        {
                            name: '长X宽X高',
                            value: '1000X650X400',
                            unit: 'mm'
                        },
                        {
                            name: '输出电压',
                            value: '800',
                            unit: 'VDC'
                        },
                        {
                            name: '电机转速',
                            value: '50000',
                            unit: 'rpm'
                        },
                        {
                            name: '燃气发生器转速',
                            value: '61000',
                            unit: 'rpm'
                        },
                        {
                            name: '使用寿命',
                            value: '≥300',
                            unit: 'h'
                        },
                        {
                            name: '启动高度',
                            value: '≥5000',
                            unit: 'm'
                        },
                        {
                            name: '使用升限',
                            value: '≥10000',
                            unit: 'm'
                        }
                    ]
                },
            },
            iconList: {
                oilConsumption: require('@/assets/engine/耗油量.png'),
                diameter: require('@/assets/engine/直径.png'),
                length: require('@/assets/engine/长度.png'),
                thrust: require('@/assets/engine/推力.png'),
                weight: require('@/assets/engine/重量.png'),
                oliRate: require('@/assets/engine/耗油率.png'),
                power:require('@/assets/engine/功率.png'),
                reductionRatio:require('@/assets/engine/比例.png'),
                generatedPower:require('@/assets/engine/发电功率.png'),
                GenerationEfficiency:require('@/assets/engine/发电效率.png'),
                airFlow:require('@/assets/engine/空气流量.png')

            },

            previousIndex: 0,
            currentIndex: 0,


        }
    },
    mounted() {
        this.scrollToDistance()
    },
    methods: {
        scrollToDistance() {
            this.id = this.$route.query.id
            if (this.$refs[this.id]) {
                this.distance = this.$refs[this.id].getBoundingClientRect().top + window.scrollY;
            }
            window.scrollTo({
                top: this.distance,
                behavior: 'smooth'
            });
        },
        handTabClick(event, value) {
            if (value.previousName != value.activeName) {
                value.importance = !value.importance
                value.all = !value.all
                value.previousName = value.activeName
            }
        },
        downFile() {
            const link = document.createElement('a')
            link.style.display = 'none'
            document.body.appendChild(link)

            // 设置文件的 URL 和名称
            link.setAttribute('download', '产品手册.pdf')
            link.setAttribute('href', `产品手册.pdf`)

            // 模拟点击链接进行下载
            link.click()

            // 移除创建的<a>标签
            document.body.removeChild(link)

        }
    },
    watch: {
        '$route.params': {
            handler() {
                this.scrollToDistance()
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.title {
    height: 100vh;
    width: 100%;
    background-image: url('../../assets/engine/页面2-1图片.jpg');
    background-repeat: no-repeat;
    background-size: cover;


    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .textArea {
        height: 20%;
        width: 100%;
        background-color: rgb(76, 76, 226, 0.5);
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-family: QHKT;
        font-weight: bold;
        font-size: 50px;
        color: white;
    }
}

::v-deep .custom-tabs {
    .el-tabs__item {
        color: rgb(0, 0, 0);
        font-size: 25px;
        width: 60px;
        line-height: 4vh;
        height: 15vh;
        writing-mode: vertical-rl;
        align-items: center;
        background-color: black;
        color: white;
        transition: all 0.3s
    }

    .el-tabs__item:hover {
        color: rgba(42, 136, 188, 1);
    }

    .el-tabs__item.is-active {
        color: black;
        background-color: white;
        border: 1px solid;
        //border-radius: 30px;
    }

    .el-tabs__header {
        float: center;
        margin-bottom: 0;
        margin-right: 10px;
        margin-top: 20vh;
    }

    .el-tabs__active-bar {
        background-color: transparent;
    }

    .el-tabs__nav-wrap {
        border: 1px solid;
        border-radius: 30px;
    }

}

::v-deep .el-tabs--left .el-tabs__item.is-left {
    display: flex;
    justify-content: center;
}

::v-deep .el-tabs--right .el-tabs__item.is-right {
    display: flex;
    justify-content: center;
}

::v-deep .el-table,
::v-deep .el-table__expanded-cell {
    background-color: transparent !important;
}

/* 表格内背景颜色 */
::v-deep .el-table th,
::v-deep .el-table tr,
::v-deep .el-table td {
    color: white;
    background-color: transparent !important;
    // border: 0; //去除表格
    font-size: 20px;
}

// /*去除底边框*/
// ::v-deep.el-table td.el-table__cell {
//     border: 0;
// }

// ::v-deep.el-table th.el-table__cell.is-leaf {
//     border: 0;
// }

/*去除底部灰条.el-table::before*/
::v-deep .el-table::before {
    display: none;
}

.engine {
    .WP {
        height: 80vh;
        width: 100%;
        background-color: #000;
        font-family: QHKT;
        color: white;

        .paramName {
            color: rgba(42, 136, 188, 1);
        }
    }

    .backgroundVideo {
        width: 100%;
        height: 100%;
    }

    .left {
        width: 45%;
        margin-top: 5%;
        margin-left: 5%;

        .introduce {
            font-size: 50px;
        }

        .parameter {
            margin-top: 10%;
            font-size: 40px;
            width: 90%;

            .parameterContent {
                display: flex;
                flex-direction: column;
                justify-content: center;
                width: 33%;
                height: 25vh;

                .parameterLine {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    font-size: 25px;
                }
            }

            .parameterContent:hover .icon {
                animation: sway .5s ease-out 0s;
            }
        }

        .parameterTable {
            width: 80%;
            // margin-top: 5%;
        }
    }

    .right {
        width: 35%;

        display: flex;
        flex-direction: column;
        align-items: center;

        .name {
            font-size: 60px;
            font-weight: bold;
            margin-top: 20%;

            .paramModel {
                display: flex;
                flex-direction: row;
                justify-content: center;
            }
        }

        .product {
            height: 50%;
            width: 100%;
        }

        .downloadButton {
            background-color: rgba($color: #777171, $alpha: 0.5);
            color: white;
            border: none;
            margin-left: 10%;
            margin-top: 1%;
        }


        .downloadButton:hover {
            background-color: #2c2727;
        }
    }

    .WP40 {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .WP60 {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .WP100 {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .WP125 {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .WP160 {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .WZ150 {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .WD200 {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }
}

.importance-enter-active {
    transition: all 0.5s;
}

.importance-enter {
    transform: translateY(100%);
    opacity: 0;
}

.all-enter-active {
    transition: all 0.5s;
}

.all-enter {
    transform: translateY(-100%);
    opacity: 0;
}


// .text-enter-active {
//     animation: bounce-in 2s;
// }

// .text-enter {
//     opacity: 0;
// }

.text-enter-active {
    transition: all 2s;
}

.text-enter {
    opacity: 0;
    transform: translateY(-50px);
}

// @keyframes bounce-in {
//     0% {
//         transform: scale(0);
//     }

//     100% {
//         transform: scale(1);
//     }
// }

@keyframes sway {
    33% {
        transform: translateX(-5px);
    }

    66% {
        transform: translateX(5px);
    }

    100% {
        transform: translateX(0px);
    }
}
</style>